import styled from '@emotion/styled'
import { useBreakpoint } from '@pharmac-extranet/shared'
import { PharmacIcon } from '@pharmac/ui'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

type Props = {
  onClick?: () => void
  text?: string
}

const BackButton = styled.button`
  outline: none;
  border: 0;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  :hover {
    .phvbb__icon {
      background-color: var(--color-purple);

      svg {
        color: var(--color-white);
      }
    }
  }

  .phvbb__icon {
    border: 2px solid var(--color-purple);
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    transition: var(--transition-cubic-bezier);

    svg {
      color: var(--color-purple);
      width: 20px;
      height: 20px;
    }
  }

  .phvbb__text {
    margin-left: var(--spacing-small);
    color: var(--color-purple);
    font-weight: bold;
    font-size: 17px;
  }
`

export const ExtranetViewReturnButton = ({ onClick, text }: Props) => {
  const { t } = useTranslation(['common'])
  const navigate = useNavigate()
  const { minDesktop } = useBreakpoint()

  const renderText = text || t('return')
  const renderOnClick = typeof onClick === 'function' ? onClick : () => navigate(-1)

  return (
    <BackButton
      className="phvbb"
      onClick={renderOnClick}
    >
      <div className="phvbb__icon">
        <PharmacIcon icon="arrowLeft" />
      </div>
      {minDesktop && <div className="phvbb__text">{renderText}</div>}
    </BackButton>
  )
}
